!(function (e) {
  "function" == typeof define && define.amd
    ? define(["jquery"], e)
    : "object" == typeof exports
    ? e(require("jquery"))
    : e(window.jQuery || window.Zepto);
})(function (c) {
  function e() {}
  function d(e, t) {
    m.ev.on(n + e + b, t);
  }
  function u(e, t, n, o) {
    var i = document.createElement("div");
    return (
      (i.className = "nov-" + e),
      n && (i.innerHTML = n),
      o ? t && t.appendChild(i) : ((i = c(i)), t && i.appendTo(t)),
      i
    );
  }
  function p(e, t) {
    m.ev.triggerHandler(n + e, t),
      m.st.callbacks &&
        ((e = e.charAt(0).toLowerCase() + e.slice(1)),
        m.st.callbacks[e] &&
          m.st.callbacks[e].apply(m, c.isArray(t) ? t : [t]));
  }
  function f(e) {
    return (
      (e === t && m.currTemplate.closeBtn) ||
        ((m.currTemplate.closeBtn = c(
          m.st.closeMarkup.replace("%title%", m.st.tClose)
        )),
        (t = e)),
      m.currTemplate.closeBtn
    );
  }
  function a() {
    c.magnificPopup.instance ||
      ((m = new e()).init(), (c.magnificPopup.instance = m));
  }
  var m,
    o,
    g,
    v,
    i,
    h,
    t,
    l = "Close",
    C = "BeforeClose",
    y = "MarkupParse",
    w = "Open",
    r = "Change",
    n = "nov",
    b = "." + n,
    I = "nov-ready",
    s = "nov-removing",
    x = "nov-prevent-close",
    k = !!window.jQuery,
    T = c(window);
  (e.prototype = {
    constructor: e,
    init: function () {
      var e = navigator.appVersion;
      (m.isIE7 = -1 !== e.indexOf("MSIE 7.")),
        (m.isIE8 = -1 !== e.indexOf("MSIE 8.")),
        (m.isLowIE = m.isIE7 || m.isIE8),
        (m.isAndroid = /android/gi.test(e)),
        (m.isIOS = /iphone|ipad|ipod/gi.test(e)),
        (m.supportsTransition = (function () {
          var e = document.createElement("p").style,
            t = ["ms", "O", "Moz", "Webkit"];
          if (void 0 !== e.transition) return !0;
          for (; t.length; ) if (t.pop() + "Transition" in e) return !0;
          return !1;
        })()),
        (m.probablyMobile =
          m.isAndroid ||
          m.isIOS ||
          /(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(
            navigator.userAgent
          )),
        (v = c(document)),
        (m.popupsCache = {});
    },
    open: function (e) {
      if (((g = g || c(document.body)), !1 === e.isObj)) {
        (m.items = e.items.toArray()), (m.index = 0);
        for (var t, n = e.items, o = 0; o < n.length; o++)
          if (((t = n[o]).parsed && (t = t.el[0]), t === e.el[0])) {
            m.index = o;
            break;
          }
      } else
        (m.items = c.isArray(e.items) ? e.items : [e.items]),
          (m.index = e.index || 0);
      if (!m.isOpen) {
        (m.types = []),
          (h = ""),
          e.mainEl && e.mainEl.length ? (m.ev = e.mainEl.eq(0)) : (m.ev = v),
          e.key
            ? (m.popupsCache[e.key] || (m.popupsCache[e.key] = {}),
              (m.currTemplate = m.popupsCache[e.key]))
            : (m.currTemplate = {}),
          (m.st = c.extend(!0, {}, c.magnificPopup.defaults, e)),
          (m.fixedContentPos =
            "auto" === m.st.fixedContentPos
              ? !m.probablyMobile
              : m.st.fixedContentPos),
          m.st.modal &&
            ((m.st.closeOnContentClick = !1),
            (m.st.closeOnBgClick = !1),
            (m.st.showCloseBtn = !1),
            (m.st.enableEscapeKey = !1)),
          m.bgOverlay ||
            ((m.bgOverlay = u("bg").on("click" + b, function () {
              m.close();
            })),
            (m.wrap = u("wrap")
              .attr("tabindex", -1)
              .on("click" + b, function (e) {
                m._checkIfClose(e.target) && m.close();
              })),
            (m.container = u("container", m.wrap))),
          (m.contentContainer = u("content")),
          m.st.preloader &&
            (m.preloader = u("preloader", m.container, m.st.tLoading));
        var i = c.magnificPopup.modules;
        for (o = 0; o < i.length; o++) {
          var a = (a = i[o]).charAt(0).toUpperCase() + a.slice(1);
          m["init" + a].call(m);
        }
        p("BeforeOpen"),
          m.st.showCloseBtn &&
            (m.st.closeBtnInside
              ? (d(y, function (e, t, n, o) {
                  n.close_replaceWith = f(o.type);
                }),
                (h += " nov-close-btn-in"))
              : m.wrap.append(f())),
          m.st.alignTop && (h += " nov-align-top"),
          m.fixedContentPos
            ? m.wrap.css({
                overflow: m.st.overflowY,
                overflowX: "hidden",
                overflowY: m.st.overflowY,
              })
            : m.wrap.css({ top: T.scrollTop(), position: "absolute" }),
          (!1 !== m.st.fixedBgPos &&
            ("auto" !== m.st.fixedBgPos || m.fixedContentPos)) ||
            m.bgOverlay.css({ height: v.height(), position: "absolute" }),
          m.st.enableEscapeKey &&
            v.on("keyup" + b, function (e) {
              27 === e.keyCode && m.close();
            }),
          T.on("resize" + b, function () {
            m.updateSize();
          }),
          m.st.closeOnContentClick || (h += " nov-auto-cursor"),
          h && m.wrap.addClass(h);
        var r = (m.wH = T.height()),
          s = {};
        m.fixedContentPos &&
          (!m._hasScrollBar(r) ||
            ((l = m._getScrollbarSize()) && (s.marginRight = l))),
          m.fixedContentPos &&
            (m.isIE7
              ? c("body, html").css("overflow", "hidden")
              : (s.overflow = "hidden"));
        var l = m.st.mainClass;
        return (
          m.isIE7 && (l += " nov-ie7"),
          l && m._addClassToMFP(l),
          m.updateItemHTML(),
          p("BuildControls"),
          c("html").css(s),
          m.bgOverlay.add(m.wrap).prependTo(m.st.prependTo || g),
          (m._lastFocusedEl = document.activeElement),
          setTimeout(function () {
            m.content
              ? (m._addClassToMFP(I), m._setFocus())
              : m.bgOverlay.addClass(I),
              v.on("focusin" + b, m._onFocusIn);
          }, 16),
          (m.isOpen = !0),
          m.updateSize(r),
          p(w),
          e
        );
      }
      m.updateItemHTML();
    },
    close: function () {
      m.isOpen &&
        (p(C),
        (m.isOpen = !1),
        m.st.removalDelay && !m.isLowIE && m.supportsTransition
          ? (m._addClassToMFP(s),
            setTimeout(function () {
              m._close();
            }, m.st.removalDelay))
          : m._close());
    },
    _close: function () {
      p(l);
      var e = s + " " + I + " ";
      m.bgOverlay.detach(),
        m.wrap.detach(),
        m.container.empty(),
        m.st.mainClass && (e += m.st.mainClass + " "),
        m._removeClassFromMFP(e),
        m.fixedContentPos &&
          ((e = { marginRight: "" }),
          m.isIE7 ? c("body, html").css("overflow", "") : (e.overflow = ""),
          c("html").css(e)),
        v.off("keyup.nov focusin" + b),
        m.ev.off(b),
        m.wrap.attr("class", "nov-wrap").removeAttr("style"),
        m.bgOverlay.attr("class", "nov-bg"),
        m.container.attr("class", "nov-container"),
        !m.st.showCloseBtn ||
          (m.st.closeBtnInside && !0 !== m.currTemplate[m.currItem.type]) ||
          (m.currTemplate.closeBtn && m.currTemplate.closeBtn.detach()),
        m._lastFocusedEl && c(m._lastFocusedEl).focus(),
        (m.currItem = null),
        (m.content = null),
        (m.currTemplate = null),
        (m.prevHeight = 0),
        p("AfterClose");
    },
    updateSize: function (e) {
      var t;
      m.isIOS
        ? ((t = document.documentElement.clientWidth / window.innerWidth),
          (t = window.innerHeight * t),
          m.wrap.css("height", t),
          (m.wH = t))
        : (m.wH = e || T.height()),
        m.fixedContentPos || m.wrap.css("height", m.wH),
        p("Resize");
    },
    updateItemHTML: function () {
      var e = m.items[m.index];
      m.contentContainer.detach(),
        m.content && m.content.detach(),
        e.parsed || (e = m.parseEl(m.index));
      var t = e.type;
      p("BeforeChange", [m.currItem ? m.currItem.type : "", t]),
        (m.currItem = e),
        m.currTemplate[t] ||
          ((n = !!m.st[t] && m.st[t].markup),
          p("FirstMarkupParse", n),
          (m.currTemplate[t] = !n || c(n))),
        i && i !== e.type && m.container.removeClass("nov-" + i + "-holder");
      var n = m["get" + t.charAt(0).toUpperCase() + t.slice(1)](
        e,
        m.currTemplate[t]
      );
      m.appendContent(n, t),
        (e.preloaded = !0),
        p(r, e),
        (i = e.type),
        m.container.prepend(m.contentContainer),
        p("AfterChange");
    },
    appendContent: function (e, t) {
      (m.content = e)
        ? m.st.showCloseBtn && m.st.closeBtnInside && !0 === m.currTemplate[t]
          ? (m.content.find(".nov-close").length &&
              m.content.find(".zmdi-close").length) ||
            m.content.append(f())
          : (m.content = e)
        : (m.content = ""),
        p("BeforeAppend"),
        m.container.addClass("nov-" + t + "-holder"),
        m.contentContainer.append(m.content);
    },
    parseEl: function (e) {
      var t,
        n = m.items[e];
      if (
        (n = n.tagName ? { el: c(n) } : ((t = n.type), { data: n, src: n.src }))
          .el
      ) {
        for (var o = m.types, i = 0; i < o.length; i++)
          if (n.el.hasClass("nov-" + o[i])) {
            t = o[i];
            break;
          }
        (n.src = n.el.attr("data-nov-src")),
          n.src || (n.src = n.el.attr("href"));
      }
      return (
        (n.type = t || m.st.type || "inline"),
        (n.index = e),
        (n.parsed = !0),
        (m.items[e] = n),
        p("ElementParse", n),
        m.items[e]
      );
    },
    addGroup: function (t, n) {
      function e(e) {
        (e.novEl = this), m._openClick(e, t, n);
      }
      var o = "click.magnificPopup";
      ((n = n || {}).mainEl = t),
        n.items
          ? ((n.isObj = !0), t.off(o).on(o, e))
          : ((n.isObj = !1),
            n.delegate
              ? t.off(o).on(o, n.delegate, e)
              : (n.items = t).off(o).on(o, e));
    },
    _openClick: function (e, t, n) {
      if (
        (void 0 !== n.midClick ? n : c.magnificPopup.defaults).midClick ||
        (2 !== e.which && !e.ctrlKey && !e.metaKey)
      ) {
        var o = (void 0 !== n.disableOn ? n : c.magnificPopup.defaults)
          .disableOn;
        if (o)
          if (c.isFunction(o)) {
            if (!o.call(m)) return !0;
          } else if (T.width() < o) return !0;
        e.type && (e.preventDefault(), m.isOpen && e.stopPropagation()),
          (n.el = c(e.novEl)),
          n.delegate && (n.items = t.find(n.delegate)),
          m.open(n);
      }
    },
    updateStatus: function (e, t) {
      var n;
      m.preloader &&
        (o !== e && m.container.removeClass("nov-s-" + o),
        t || "loading" !== e || (t = m.st.tLoading),
        p("UpdateStatus", (n = { status: e, text: t })),
        (e = n.status),
        (t = n.text),
        m.preloader.html(t),
        m.preloader.find("a").on("click", function (e) {
          e.stopImmediatePropagation();
        }),
        m.container.addClass("nov-s-" + e),
        (o = e));
    },
    _checkIfClose: function (e) {
      if (!c(e).hasClass(x)) {
        var t = m.st.closeOnContentClick,
          n = m.st.closeOnBgClick;
        if (t && n) return !0;
        if (
          !m.content ||
          c(e).hasClass("nov-close") ||
          c(e).hasClass("zmdi-close") ||
          (m.preloader && e === m.preloader[0])
        )
          return !0;
        if (e === m.content[0] || c.contains(m.content[0], e)) {
          if (t) return !0;
        } else if (n && c.contains(document, e)) return !0;
        return !1;
      }
    },
    _addClassToMFP: function (e) {
      m.bgOverlay.addClass(e), m.wrap.addClass(e);
    },
    _removeClassFromMFP: function (e) {
      this.bgOverlay.removeClass(e), m.wrap.removeClass(e);
    },
    _hasScrollBar: function (e) {
      return (
        (m.isIE7 ? v.height() : document.body.scrollHeight) > (e || T.height())
      );
    },
    _setFocus: function () {
      (m.st.focus ? m.content.find(m.st.focus).eq(0) : m.wrap).focus();
    },
    _onFocusIn: function (e) {
      if (e.target !== m.wrap[0] && !c.contains(m.wrap[0], e.target))
        return m._setFocus(), !1;
    },
    _parseMarkup: function (i, e, t) {
      var a;
      t.data && (e = c.extend(t.data, e)),
        p(y, [i, e, t]),
        c.each(e, function (e, t) {
          return (
            void 0 === t ||
            !1 === t ||
            void (1 < (a = e.split("_")).length
              ? 0 < (n = i.find(b + "-" + a[0])).length &&
                ("replaceWith" === (o = a[1])
                  ? n[0] !== t[0] && n.replaceWith(t)
                  : "img" === o
                  ? n.is("img")
                    ? n.attr("src", t)
                    : n.replaceWith(
                        '<img src="' +
                          t +
                          '" class="' +
                          n.attr("class") +
                          '" />'
                      )
                  : n.attr(a[1], t))
              : i.find(b + "-" + e).html(t))
          );
          var n, o;
        });
    },
    _getScrollbarSize: function () {
      var e;
      return (
        void 0 === m.scrollbarSize &&
          (((e = document.createElement("div")).style.cssText =
            "width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;"),
          document.body.appendChild(e),
          (m.scrollbarSize = e.offsetWidth - e.clientWidth),
          document.body.removeChild(e)),
        m.scrollbarSize
      );
    },
  }),
    (c.magnificPopup = {
      instance: null,
      proto: e.prototype,
      modules: [],
      open: function (e, t) {
        return (
          a(),
          ((e = e ? c.extend(!0, {}, e) : {}).isObj = !0),
          (e.index = t || 0),
          this.instance.open(e)
        );
      },
      close: function () {
        return c.magnificPopup.instance && c.magnificPopup.instance.close();
      },
      registerModule: function (e, t) {
        t.options && (c.magnificPopup.defaults[e] = t.options),
          c.extend(this.proto, t.proto),
          this.modules.push(e);
      },
      defaults: {
        disableOn: 0,
        key: null,
        midClick: !1,
        mainClass: "",
        preloader: !0,
        focus: "",
        closeOnContentClick: !1,
        closeOnBgClick: !0,
        closeBtnInside: !0,
        showCloseBtn: !0,
        enableEscapeKey: !0,
        modal: !1,
        alignTop: !1,
        removalDelay: 0,
        prependTo: null,
        fixedContentPos: "auto",
        fixedBgPos: "auto",
        overflowY: "auto",
        closeMarkup:
          '<button title="%title%" type="button" class="nov-close">x</button>',
        tClose: "Close (Esc)",
        tLoading: "Loading...",
      },
    }),
    (c.fn.magnificPopup = function (e) {
      a();
      var t,
        n,
        o,
        i = c(this);
      return (
        "string" == typeof e
          ? "open" === e
            ? ((t = k ? i.data("magnificPopup") : i[0].magnificPopup),
              (n = parseInt(arguments[1], 10) || 0),
              (o = t.items
                ? t.items[n]
                : ((o = i), t.delegate && (o = o.find(t.delegate)), o.eq(n))),
              m._openClick({ novEl: o }, i, t))
            : m.isOpen &&
              m[e].apply(m, Array.prototype.slice.call(arguments, 1))
          : ((e = c.extend(!0, {}, e)),
            k ? i.data("magnificPopup", e) : (i[0].magnificPopup = e),
            m.addGroup(i, e)),
        i
      );
    });
  function _() {
    P && (S.after(P.addClass(E)).detach(), (P = null));
  }
  var E,
    S,
    P,
    z = "inline";
  c.magnificPopup.registerModule(z, {
    options: {
      hiddenClass: "hide",
      markup: "",
      tNotFound: "Content not found",
    },
    proto: {
      initInline: function () {
        m.types.push(z),
          d(l + "." + z, function () {
            _();
          });
      },
      getInline: function (e, t) {
        if ((_(), e.src)) {
          var n,
            o = m.st.inline,
            i = c(e.src);
          return (
            i.length
              ? ((n = i[0].parentNode) &&
                  n.tagName &&
                  (S || ((E = o.hiddenClass), (S = u(E)), (E = "nov-" + E)),
                  (P = i.after(S).detach().removeClass(E))),
                m.updateStatus("ready"))
              : (m.updateStatus("error", o.tNotFound), (i = c("<div>"))),
            (e.inlineElement = i)
          );
        }
        return m.updateStatus("ready"), m._parseMarkup(t, {}, e), t;
      },
    },
  });
  function O() {
    B && g.removeClass(B);
  }
  function M() {
    O(), m.req && m.req.abort();
  }
  var B,
    F = "ajax";
  c.magnificPopup.registerModule(F, {
    options: {
      settings: null,
      cursor: "nov-ajax-cur",
      tError: '<a href="%url%">The content</a> could not be loaded.',
    },
    proto: {
      initAjax: function () {
        m.types.push(F),
          (B = m.st.ajax.cursor),
          d(l + "." + F, M),
          d("BeforeChange." + F, M);
      },
      getAjax: function (o) {
        B && g.addClass(B), m.updateStatus("loading");
        var e = c.extend(
          {
            url: o.src,
            success: function (e, t, n) {
              n = { data: e, xhr: n };
              p("ParseAjax", n),
                m.appendContent(c(n.data), F),
                (o.finished = !0),
                O(),
                m._setFocus(),
                setTimeout(function () {
                  m.wrap.addClass(I);
                }, 16),
                m.updateStatus("ready"),
                p("AjaxContentAdded");
            },
            error: function () {
              O(),
                (o.finished = o.loadError = !0),
                m.updateStatus(
                  "error",
                  m.st.ajax.tError.replace("%url%", o.src)
                );
            },
          },
          m.st.ajax.settings
        );
        return (m.req = c.ajax(e)), "";
      },
    },
  });
  var H;
  c.magnificPopup.registerModule("image", {
    options: {
      markup:
        '<div class="nov-figure"><div class="nov-close"></div><figure><div class="nov-img"></div><figcaption><div class="nov-bottom-bar"><div class="nov-title"></div><div class="nov-counter"></div></div></figcaption></figure></div>',
      cursor: "nov-zoom-out-cur",
      titleSrc: "title",
      verticalFit: !0,
      tError: '<a href="%url%">The image</a> could not be loaded.',
    },
    proto: {
      initImage: function () {
        var e = m.st.image,
          t = ".image";
        m.types.push("image"),
          d(w + t, function () {
            "image" === m.currItem.type && e.cursor && g.addClass(e.cursor);
          }),
          d(l + t, function () {
            e.cursor && g.removeClass(e.cursor), T.off("resize" + b);
          }),
          d("Resize" + t, m.resizeImage),
          m.isLowIE && d("AfterChange", m.resizeImage);
      },
      resizeImage: function () {
        var e,
          t = m.currItem;
        t &&
          t.img &&
          m.st.image.verticalFit &&
          ((e = 0),
          m.isLowIE &&
            (e =
              parseInt(t.img.css("padding-top"), 10) +
              parseInt(t.img.css("padding-bottom"), 10)),
          t.img.css("max-height", m.wH - e));
      },
      _onImageHasSize: function (e) {
        e.img &&
          ((e.hasSize = !0),
          H && clearInterval(H),
          (e.isCheckingImgSize = !1),
          p("ImageHasSize", e),
          e.imgHidden &&
            (m.content && m.content.removeClass("nov-loading"),
            (e.imgHidden = !1)));
      },
      findImageSize: function (t) {
        var n = 0,
          o = t.img[0],
          i = function (e) {
            H && clearInterval(H),
              (H = setInterval(function () {
                0 < o.naturalWidth
                  ? m._onImageHasSize(t)
                  : (200 < n && clearInterval(H),
                    3 === ++n ? i(10) : 40 === n ? i(50) : 100 === n && i(500));
              }, e));
          };
        i(1);
      },
      getImage: function (e, t) {
        var n,
          o = 0,
          i = function () {
            e &&
              (e.img[0].complete
                ? (e.img.off(".novloader"),
                  e === m.currItem &&
                    (m._onImageHasSize(e), m.updateStatus("ready")),
                  (e.hasSize = !0),
                  (e.loaded = !0),
                  p("ImageLoadComplete"))
                : ++o < 200
                ? setTimeout(i, 100)
                : a());
          },
          a = function () {
            e &&
              (e.img.off(".novloader"),
              e === m.currItem &&
                (m._onImageHasSize(e),
                m.updateStatus("error", r.tError.replace("%url%", e.src))),
              (e.hasSize = !0),
              (e.loaded = !0),
              (e.loadError = !0));
          },
          r = m.st.image,
          s = t.find(".nov-img");
        return (
          s.length &&
            (((n = document.createElement("img")).className = "nov-img"),
            e.el &&
              e.el.find("img").length &&
              (n.alt = e.el.find("img").attr("alt")),
            (e.img = c(n).on("load.novloader", i).on("error.novloader", a)),
            (n.src = e.src),
            s.is("img") && (e.img = e.img.clone()),
            0 < (n = e.img[0]).naturalWidth
              ? (e.hasSize = !0)
              : n.width || (e.hasSize = !1)),
          m._parseMarkup(
            t,
            {
              title: (function (e) {
                if (e.data && void 0 !== e.data.title) return e.data.title;
                var t = m.st.image.titleSrc;
                if (t) {
                  if (c.isFunction(t)) return t.call(m, e);
                  if (e.el) return e.el.attr(t) || "";
                }
                return "";
              })(e),
              img_replaceWith: e.img,
            },
            e
          ),
          m.resizeImage(),
          e.hasSize
            ? (H && clearInterval(H),
              e.loadError
                ? (t.addClass("nov-loading"),
                  m.updateStatus("error", r.tError.replace("%url%", e.src)))
                : (t.removeClass("nov-loading"), m.updateStatus("ready")))
            : (m.updateStatus("loading"),
              (e.loading = !0),
              e.hasSize ||
                ((e.imgHidden = !0),
                t.addClass("nov-loading"),
                m.findImageSize(e))),
          t
        );
      },
    },
  });
  var L;
  c.magnificPopup.registerModule("zoom", {
    options: {
      enabled: !1,
      easing: "ease-in-out",
      duration: 300,
      opener: function (e) {
        return e.is("img") ? e : e.find("img");
      },
    },
    proto: {
      initZoom: function () {
        var e,
          t,
          n,
          o,
          i,
          a,
          r = m.st.zoom,
          s = ".zoom";
        r.enabled &&
          m.supportsTransition &&
          ((t = r.duration),
          (n = function (e) {
            var t = e
                .clone()
                .removeAttr("style")
                .removeAttr("class")
                .addClass("nov-animated-image"),
              n = "all " + r.duration / 1e3 + "s " + r.easing,
              o = {
                position: "fixed",
                zIndex: 9999,
                left: 0,
                top: 0,
                "-webkit-backface-visibility": "hidden",
              },
              e = "transition";
            return (
              (o["-webkit-" + e] = o["-moz-" + e] = o["-o-" + e] = o[e] = n),
              t.css(o),
              t
            );
          }),
          (o = function () {
            m.content.css("visibility", "visible");
          }),
          d("BuildControls" + s, function () {
            m._allowZoom() &&
              (clearTimeout(i),
              m.content.css("visibility", "hidden"),
              (e = m._getItemToZoom())
                ? ((a = n(e)).css(m._getOffset()),
                  m.wrap.append(a),
                  (i = setTimeout(function () {
                    a.css(m._getOffset(!0)),
                      (i = setTimeout(function () {
                        o(),
                          setTimeout(function () {
                            a.remove(), (e = a = null), p("ZoomAnimationEnded");
                          }, 16);
                      }, t));
                  }, 16)))
                : o());
          }),
          d(C + s, function () {
            if (m._allowZoom()) {
              if ((clearTimeout(i), (m.st.removalDelay = t), !e)) {
                if (!(e = m._getItemToZoom())) return;
                a = n(e);
              }
              a.css(m._getOffset(!0)),
                m.wrap.append(a),
                m.content.css("visibility", "hidden"),
                setTimeout(function () {
                  a.css(m._getOffset());
                }, 16);
            }
          }),
          d(l + s, function () {
            m._allowZoom() && (o(), a && a.remove(), (e = null));
          }));
      },
      _allowZoom: function () {
        return "image" === m.currItem.type;
      },
      _getItemToZoom: function () {
        return !!m.currItem.hasSize && m.currItem.img;
      },
      _getOffset: function (e) {
        var t = e
            ? m.currItem.img
            : m.st.zoom.opener(m.currItem.el || m.currItem),
          n = t.offset(),
          o = parseInt(t.css("padding-top"), 10),
          e = parseInt(t.css("padding-bottom"), 10);
        n.top -= c(window).scrollTop() - o;
        o = {
          width: t.width(),
          height: (k ? t.innerHeight() : t[0].offsetHeight) - e - o,
        };
        return (
          void 0 === L &&
            (L = void 0 !== document.createElement("p").style.MozTransform),
          L
            ? (o["-moz-transform"] = o.transform =
                "translate(" + n.left + "px," + n.top + "px)")
            : ((o.left = n.left), (o.top = n.top)),
          o
        );
      },
    },
  });
  function A(e) {
    var t;
    !m.currTemplate[j] ||
      ((t = m.currTemplate[j].find("iframe")).length &&
        (e || (t[0].src = "//about:blank"),
        m.isIE8 && t.css("display", e ? "block" : "none")));
  }
  var j = "iframe";
  c.magnificPopup.registerModule(j, {
    options: {
      markup:
        '<div class="nov-iframe-scaler"><div class="nov-close"></div><iframe class="nov-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',
      srcAction: "iframe_src",
      patterns: {
        youtube: {
          index: "youtube.com",
          id: "v=",
          src: "//www.youtube.com/embed/%id%?autoplay=1",
        },
        vimeo: {
          index: "vimeo.com/",
          id: "/",
          src: "//player.vimeo.com/video/%id%?autoplay=1",
        },
        gmaps: { index: "//maps.google.", src: "%id%&output=embed" },
      },
    },
    proto: {
      initIframe: function () {
        m.types.push(j),
          d("BeforeChange", function (e, t, n) {
            t !== n && (t === j ? A() : n === j && A(!0));
          }),
          d(l + "." + j, function () {
            A();
          });
      },
      getIframe: function (e, t) {
        var n = e.src,
          o = m.st.iframe;
        c.each(o.patterns, function () {
          if (-1 < n.indexOf(this.index))
            return (
              this.id &&
                (n =
                  "string" == typeof this.id
                    ? n.substr(
                        n.lastIndexOf(this.id) + this.id.length,
                        n.length
                      )
                    : this.id.call(this, n)),
              (n = this.src.replace("%id%", n)),
              !1
            );
        });
        var i = {};
        return (
          o.srcAction && (i[o.srcAction] = n),
          m._parseMarkup(t, i, e),
          m.updateStatus("ready"),
          t
        );
      },
    },
  });
  function N(e) {
    var t = m.items.length;
    return t - 1 < e ? e - t : e < 0 ? t + e : e;
  }
  function W(e, t, n) {
    return e.replace(/%curr%/gi, t + 1).replace(/%total%/gi, n);
  }
  c.magnificPopup.registerModule("gallery", {
    options: {
      enabled: !1,
      arrowMarkup:
        '<button title="%title%" type="button" class="nov-arrow nov-arrow-%dir%"></button>',
      preload: [0, 2],
      navigateByImgClick: !0,
      arrows: !0,
      tPrev: "Previous (Left arrow key)",
      tNext: "Next (Right arrow key)",
      tCounter: "%curr% of %total%",
    },
    proto: {
      initGallery: function () {
        var a = m.st.gallery,
          e = ".nov-gallery",
          o = Boolean(c.fn.novFastClick);
        if (((m.direction = !0), !a || !a.enabled)) return !1;
        (h += " nov-gallery"),
          d(w + e, function () {
            a.navigateByImgClick &&
              m.wrap.on("click" + e, ".nov-img", function () {
                if (1 < m.items.length) return m.next(), !1;
              }),
              v.on("keydown" + e, function (e) {
                37 === e.keyCode ? m.prev() : 39 === e.keyCode && m.next();
              });
          }),
          d("UpdateStatus" + e, function (e, t) {
            t.text && (t.text = W(t.text, m.currItem.index, m.items.length));
          }),
          d(y + e, function (e, t, n, o) {
            var i = m.items.length;
            n.counter = 1 < i ? W(a.tCounter, o.index, i) : "";
          }),
          d("BuildControls" + e, function () {
            var e, t, n;
            1 < m.items.length &&
              a.arrows &&
              !m.arrowLeft &&
              ((n = a.arrowMarkup),
              (e = m.arrowLeft =
                c(
                  n.replace(/%title%/gi, a.tPrev).replace(/%dir%/gi, "left")
                ).addClass(x)),
              (t = m.arrowRight =
                c(
                  n.replace(/%title%/gi, a.tNext).replace(/%dir%/gi, "right")
                ).addClass(x)),
              e[(n = o ? "novFastClick" : "click")](function () {
                m.prev();
              }),
              t[n](function () {
                m.next();
              }),
              m.isIE7 &&
                (u("b", e[0], !1, !0),
                u("a", e[0], !1, !0),
                u("b", t[0], !1, !0),
                u("a", t[0], !1, !0)),
              m.container.append(e.add(t)));
          }),
          d(r + e, function () {
            m._preloadTimeout && clearTimeout(m._preloadTimeout),
              (m._preloadTimeout = setTimeout(function () {
                m.preloadNearbyImages(), (m._preloadTimeout = null);
              }, 16));
          }),
          d(l + e, function () {
            v.off(e),
              m.wrap.off("click" + e),
              m.arrowLeft &&
                o &&
                m.arrowLeft.add(m.arrowRight).destroyNovFastClick(),
              (m.arrowRight = m.arrowLeft = null);
          });
      },
      next: function () {
        (m.direction = !0), (m.index = N(m.index + 1)), m.updateItemHTML();
      },
      prev: function () {
        (m.direction = !1), (m.index = N(m.index - 1)), m.updateItemHTML();
      },
      goTo: function (e) {
        (m.direction = e >= m.index), (m.index = e), m.updateItemHTML();
      },
      preloadNearbyImages: function () {
        for (
          var e = m.st.gallery.preload,
            t = Math.min(e[0], m.items.length),
            n = Math.min(e[1], m.items.length),
            o = 1;
          o <= (m.direction ? n : t);
          o++
        )
          m._preloadItem(m.index + o);
        for (o = 1; o <= (m.direction ? t : n); o++)
          m._preloadItem(m.index - o);
      },
      _preloadItem: function (e) {
        var t;
        (e = N(e)),
          m.items[e].preloaded ||
            ((t = m.items[e]).parsed || (t = m.parseEl(e)),
            p("LazyLoad", t),
            "image" === t.type &&
              (t.img = c('<img class="nov-img" />')
                .on("load.novloader", function () {
                  t.hasSize = !0;
                })
                .on("error.novloader", function () {
                  (t.hasSize = !0), (t.loadError = !0), p("LazyLoadError", t);
                })
                .attr("src", t.src)),
            (t.preloaded = !0));
      },
    },
  });
  var R,
    Z,
    q = "retina";
  function D() {
    T.off("touchmove" + Z + " touchend" + Z);
  }
  c.magnificPopup.registerModule(q, {
    options: {
      replaceSrc: function (e) {
        return e.src.replace(/\.\w+$/, function (e) {
          return "@2x" + e;
        });
      },
      ratio: 1,
    },
    proto: {
      initRetina: function () {
        var n, o;
        1 < window.devicePixelRatio &&
          ((n = m.st.retina),
          (o = n.ratio),
          1 < (o = isNaN(o) ? o() : o) &&
            (d("ImageHasSize." + q, function (e, t) {
              t.img.css({
                "max-width": t.img[0].naturalWidth / o,
                width: "100%",
              });
            }),
            d("ElementParse." + q, function (e, t) {
              t.src = n.replaceSrc(t, o);
            })));
      },
    },
  }),
    (R = "ontouchstart" in window),
    (Z = ".novFastClick"),
    (c.fn.novFastClick = function (l) {
      return c(this).each(function () {
        var t,
          n,
          o,
          i,
          a,
          r,
          s,
          e = c(this);
        R &&
          e.on("touchstart" + Z, function (e) {
            (a = !1),
              (s = 1),
              (r = (e.originalEvent || e).touches[0]),
              (o = r.clientX),
              (i = r.clientY),
              T.on("touchmove" + Z, function (e) {
                (r = (e.originalEvent || e).touches),
                  (s = r.length),
                  (r = r[0]),
                  (10 < Math.abs(r.clientX - o) ||
                    10 < Math.abs(r.clientY - i)) &&
                    ((a = !0), D());
              }).on("touchend" + Z, function (e) {
                D(),
                  a ||
                    1 < s ||
                    ((t = !0),
                    e.preventDefault(),
                    clearTimeout(n),
                    (n = setTimeout(function () {
                      t = !1;
                    }, 1e3)),
                    l());
              });
          }),
          e.on("click" + Z, function () {
            t || l();
          });
      });
    }),
    (c.fn.destroyNovFastClick = function () {
      c(this).off("touchstart" + Z + " click" + Z),
        R && T.off("touchmove" + Z + " touchend" + Z);
    }),
    a();
});
